import request from '@/utils/request'
import {encode} from '@/utils/encryption'

// 登录
export function login (username, password) {
  return request.post('/api/login', {
    username,
    password: encode(password)
  })
}

// 退出
export function logout () {
  return request.post('/api/user/logout')
}

// 获取用户信息
export function getInfo (token) {
  return request.get('/api/admin/user/info', {token})
}

// 获取注册时的验证
export function getRegisterCode (data) {
  return request.get('/api/register/verify-code', data)
}

// 注册时发送验证码
export function postRegisterCode (data) {
  return request.post('/api/register/verify-code', data)
}

// 获取重置密码时的验证
export function getModifyPasswordCode (data) {
  return request.get('/api/forget-password/verify-code', data)
}

// 重置密码时发送验证码
export function postModifyPasswordCode (data) {
  return request.post('/api/forget-password/verify-code', data)
}

// 修改密码
export function changePassword ({username, password, code}) {
  return request.post('/api/forget-password', {
    username,
    password: encode(password),
    code
  })
}

//注册
export function register ({username, password, code}) {
  return request.post('/api/register', {
    username,
    password: encode(password),
    code
  })
}




// WEBPACK FOOTER //
// ./src/api/users.js